/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */

// Korean (한국어)
export default {
	'Type something': '무엇이든 입력하세요',
	'About Jodit': 'Jodit에 대하여',
	'Jodit Editor': 'Jodit Editor',
	"Jodit User's Guide": 'Jodit 사용자 안내서',
	'contains detailed help for using': '자세한 도움말이 들어있어요',
	'For information about the license, please go to our website:':
		'라이센스에 관해서는 Jodit 웹 사이트를 방문해주세요：',
	'Buy full version': '풀 버전 구입하기',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'© XDSoft.net - Chupurnov Valeriy. 에게 저작권과 모든 권리가 있습니다.',
	Anchor: 'Anchor',
	'Open in new tab': '새 탭에서 열기',
	'Open in fullsize': '전체 크기로 보기',
	'Clear Formatting': '서식 지우기',
	'Fill color or set the text color': '글씨 색상',
	Redo: '재실행',
	Undo: '실행 취소',
	Bold: '굵게',
	Italic: '기울임',
	'Insert Unordered List': '글머리 목록',
	'Insert Ordered List': '번호 목록',
	'Align Center': '가운데 정렬',
	'Align Justify': '양쪽 정렬',
	'Align Left': '왼쪽 정렬',
	'Align Right': '오른쪽 정렬',
	'Insert Horizontal Line': '수평 구분선 넣기',
	'Insert Image': '이미지 넣기',
	'Insert file': '파일 넣기',
	'Insert youtube/vimeo video': 'Youtube/Vimeo 동영상',
	'Insert link': '링크 넣기',
	'Font size': '글꼴 크기',
	'Font family': '글꼴',
	'Insert format block': '블록 요소 넣기',
	Normal: '일반 텍스트',
	'Heading 1': '제목 1',
	'Heading 2': '제목 2',
	'Heading 3': '제목 3',
	'Heading 4': '제목 4',
	Quote: '인용',
	Code: '코드',
	Insert: '붙여 넣기',
	'Insert table': '테이블',
	'Decrease Indent': '들여쓰기 감소',
	'Increase Indent': '들여쓰기 증가',
	'Select Special Character': '특수문자 선택',
	'Insert Special Character': '특수문자 입력',
	'Paint format': '페인트 형식',
	'Change mode': '편집모드 변경',
	Margins: '마진',
	top: '위',
	right: '오른쪽',
	bottom: '아래',
	left: '왼쪽',
	Styles: '스타일',
	Classes: '클래스',
	Align: '정렬',
	Right: '오른쪽으로',
	Center: '가운데로',
	Left: '왼쪽으로',
	'--Not Set--': '--지정 안 함--',
	Src: '경로(src)',
	Title: '제목',
	Alternative: '대체 텍스트(alt)',
	Link: '링크',
	'Open link in new tab': '새 탭에서 열기',
	file: '파일',
	Advanced: '고급',
	'Image properties': '이미지 속성',
	Cancel: '취소',
	Ok: '확인',
	'Your code is similar to HTML. Keep as HTML?':
		'HTML 코드로 감지했어요. 코드인채로 붙여넣을까요?',
	'Paste as HTML': 'HTML로 붙여넣기',
	Keep: '원본 유지',
	Clean: '지우기',
	'Insert as Text': '텍스트로 넣기',
	'Insert only Text': '텍스트만 넣기',
	'Word Paste Detected': 'Word 붙여넣기 감지',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'Microsoft Word/Excel 문서로 감지했어요. 서식을 유지한채로 붙여넣을까요?',
	'File Browser': '파일 탐색기',
	'Error on load list': '목록 불러오기 에러',
	'Error on load folders': '폴더 불러오기',
	'Are you sure?': '정말 진행할까요?',
	'Enter Directory name': '디렉토리 이름 입력',
	'Create directory': '디렉토리 생성',
	'type name': '이름 입력',
	'Drop image': '이미지 드래그',
	'Drop file': '파일 드래그',
	'or click': '혹은 클릭',
	'Alternative text': '대체 텍스트',
	Browse: '탐색',
	Upload: '업로드',
	Background: '배경',
	Text: '텍스트',
	Top: '위',
	Middle: '중앙',
	Bottom: '아래',
	'Insert column before': '이전 열에 삽입',
	'Insert column after': '다음 열에 삽입',
	'Insert row above': '위 행에 삽입',
	'Insert row below': '아래 행에 삽입',
	'Delete table': '테이블 삭제',
	'Delete row': '행 삭제',
	'Delete column': '열 삭제',
	'Empty cell': '빈 셀',
	source: 'HTML 소스',
	bold: '볼드',
	italic: '이탤릭',
	brush: '브러시',
	link: '링크',
	undo: '실행 취소',
	redo: '재실행',
	table: '테이블',
	image: '이미지',
	eraser: '지우개',
	paragraph: '문단',
	fontsize: '글꼴 크기',
	video: '비디오',
	font: '글꼴',
	about: '편집기 정보',
	print: '프린트',
	underline: '밑줄',
	strikethrough: '취소선',
	indent: '들여쓰기',
	outdent: '내어쓰기',
	fullsize: '전체 화면',
	shrink: '일반 화면',
	hr: '구분선',
	ul: '글머리 목록',
	ol: '번호 목록',
	cut: '잘라내기',
	selectall: '모두 선택',
	'Embed code': 'Embed 코드',
	'Open link': '링크 열기',
	'Edit link': '링크 편집',
	'No follow': 'No follow',
	Unlink: '링크 제거',
	Eye: '사이트 확인',
	pencil: '연필',
	Update: '갱신',
	' URL': 'URL',
	Edit: '편집',
	'Horizontal align': '수평 정렬',
	Filter: '필터',
	'Sort by changed': '변경일 정렬',
	'Sort by name': '이름 정렬',
	'Sort by size': '크기 정렬',
	'Add folder': '새 폴더',
	Reset: '초기화',
	Save: '저장',
	'Save as ...': '새로 저장하기 ...',
	Resize: '리사이즈',
	Crop: '크롭',
	Width: '가로 길이',
	Height: '세로 높이',
	'Keep Aspect Ratio': '비율 유지하기',
	Yes: '네',
	No: '아니오',
	Remove: '제거',
	Select: '선택',
	'Chars: %d': '문자수: %d',
	'Words: %d': '단어수: %d',
	All: '모두',
	'Select all': '모두 선택',
	'Select %s': '선택: %s',
	'Vertical align': '수직 정렬',
	Split: '분할',
	'Split vertical': '세로 셀 분할',
	'Split horizontal': '가로 셀 분할',
	Merge: '셀 병합',
	'Add column': '열 추가',
	'Add row': '행 추가',
	Delete: '삭제',
	Border: '외곽선',
	'License: %s': '라이센스: %s',
	'Strike through': '취소선',
	Underline: '밑줄',
	superscript: '윗첨자',
	subscript: '아래첨자',
	'Cut selection': '선택 잘라내기',
	Break: '구분자',
	'Search for': '검색',
	'Replace with': '대체하기',
	Replace: '대체',
	Paste: '붙여넣기',
	'Choose Content to Paste': '붙여넣을 내용 선택',
	'You can only edit your own images. Download this image on the host?':
		'외부 이미지는 편집할 수 없어요. 외부 이미지를 다운로드 할까요?',
	'The image has been successfully uploaded to the host!':
		'이미지를 무사히 업로드 했어요!',
	palette: '팔레트',
	'There are no files': '파일이 없어요',
	Rename: '이름 변경',
	'Enter new name': '새 이름 입력',
	preview: '미리보기',
	download: '다운로드',
	'Paste from clipboard': '클립보드 붙여넣기',
	"Your browser doesn't support direct access to the clipboard.":
		'사용중인 브라우저가 클립보드 접근을 지원하지 않아요.',
	'Copy selection': '선택 복사',
	copy: '복사',
	'Border radius': '둥근 테두리',
	'Show all': '모두 보기',
	Apply: '적용',
	'Please fill out this field': '이 항목을 입력해주세요!',
	'Please enter a web address': '웹 URL을 입력해주세요.',
	Default: '기본',
	Circle: '원',
	Dot: '점',
	Quadrate: '정사각형',
	Find: '찾기',
	'Find Previous': '이전 찾기',
	'Find Next': '다음 찾기',
	'Insert className': 'className 입력',
	'Press Alt for custom resizing':
		'사용자 지정 크기 조정에 대 한 고도 누르십시오'
};
